export const MIN_FIELD_LENGTH = 2;
export const MAX_FIELD_LENGTH = 255;
export const MAX_DESCRIPTION_FILED_LENGTH = 1023;
